export default __webpack_public_path__ + "static/media/shopWomens.81fa5624.jpg";